// Mock data for Yamil Marquez Sports Photography Website

export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      gallery: 'Galerie',
      about: 'À Propos',
      testimonials: 'Témoignages',
      contact: 'Contact'
    },
    hero: {
      title: 'Capturer la Passion',
      subtitle: 'du Sport',
      description: 'Photographie sportive professionnelle qui capture les émotions réelles et les moments décisifs',
      cta: 'Voir Mon Travail'
    },
    about: {
      title: 'À Propos de Moi',
      bio: "Salut, je suis Yamil Marquez - Photographe sportif basé au Canada. Je capture les émotions réelles, les moments décisifs et la passion du sport. Chaque photo raconte une histoire de détermination, de victoire et d'esprit humain.",
      experience: 'Années d\'Expérience',
      projects: 'Projets Réalisés',
      sports: 'Types de Sports'
    },
    gallery: {
      title: 'Portfolio',
      subtitle: 'Une sélection de mes meilleurs moments capturés',
      categories: {
        all: 'Tous',
        team: 'Sports d\'Équipe',
        individual: 'Sports Individuels',
        extreme: 'Sports Extrêmes',
        motor: 'Sports Motorisés'
      }
    },
    testimonials: {
      title: 'Ce que Disent Mes Clients',
      subtitle: 'Témoignages de clients satisfaits',
      items: [
        {
          name: 'Marc Dubois',
          role: 'Entraîneur de Basketball',
          text: 'Yamil a capturé l\'essence de notre équipe. Ses photos racontent l\'histoire de chaque match avec une émotion incroyable.',
          rating: 5
        },
        {
          name: 'Sophie Laurent',
          role: 'Athlète Professionnelle',
          text: 'Un photographe exceptionnel qui sait exactement quand appuyer sur le déclencheur. Chaque photo est une œuvre d\'art.',
          rating: 5
        },
        {
          name: 'Jean Martin',
          role: 'Directeur Sportif',
          text: 'Professionnalisme et créativité. Yamil comprend le sport et cela se voit dans son travail.',
          rating: 5
        }
      ]
    },
    contact: {
      title: 'Travaillons Ensemble',
      subtitle: 'Contactez-moi pour discuter de votre projet',
      form: {
        name: 'Nom Complet',
        email: 'Email',
        phone: 'Téléphone',
        sport: 'Type de Sport',
        message: 'Message',
        submit: 'Envoyer le Message',
        sending: 'Envoi...',
        success: 'Message envoyé avec succès!',
        error: 'Erreur lors de l\'envoi. Veuillez réessayer.'
      },
      info: {
        title: 'Informations de Contact',
        email: 'Email',
        phone: 'Téléphone',
        location: 'Lieu',
        instagram: 'Instagram'
      }
    },
    footer: {
      rights: 'Tous droits réservés.',
      tagline: 'Photographe Sportif Professionnel'
    }
  },
  en: {
    nav: {
      home: 'Home',
      gallery: 'Gallery',
      about: 'About',
      testimonials: 'Testimonials',
      contact: 'Contact'
    },
    hero: {
      title: 'Capturing the Passion',
      subtitle: 'of Sports',
      description: 'Professional sports photography that captures real emotions and decisive moments',
      cta: 'View My Work'
    },
    about: {
      title: 'About Me',
      bio: "Hi, I'm Yamil Marquez--Sports Photographer based in Canada. I capture real emotions, decisive moments, and the passion of sports. Every photo tells a story of determination, victory, and the human spirit.",
      experience: 'Years Experience',
      projects: 'Projects Completed',
      sports: 'Sports Covered'
    },
    gallery: {
      title: 'Portfolio',
      subtitle: 'A selection of my best captured moments',
      categories: {
        all: 'All',
        team: 'Team Sports',
        individual: 'Individual Sports',
        extreme: 'Extreme Sports',
        motor: 'Motor Sports'
      }
    },
    testimonials: {
      title: 'What My Clients Say',
      subtitle: 'Testimonials from satisfied clients',
      items: [
        {
          name: 'Marc Dubois',
          role: 'Basketball Coach',
          text: 'Yamil captured the essence of our team. His photos tell the story of every game with incredible emotion.',
          rating: 5
        },
        {
          name: 'Sophie Laurent',
          role: 'Professional Athlete',
          text: 'An exceptional photographer who knows exactly when to press the shutter. Every photo is a work of art.',
          rating: 5
        },
        {
          name: 'Jean Martin',
          role: 'Sports Director',
          text: 'Professionalism and creativity. Yamil understands sports and it shows in his work.',
          rating: 5
        }
      ]
    },
    contact: {
      title: 'Let\'s Work Together',
      subtitle: 'Get in touch to discuss your project',
      form: {
        name: 'Full Name',
        email: 'Email',
        phone: 'Phone',
        sport: 'Sport Type',
        message: 'Message',
        submit: 'Send Message',
        sending: 'Sending...',
        success: 'Message sent successfully!',
        error: 'Error sending message. Please try again.'
      },
      info: {
        title: 'Contact Information',
        email: 'Email',
        phone: 'Phone',
        location: 'Location',
        instagram: 'Instagram'
      }
    },
    footer: {
      rights: 'All rights reserved.',
      tagline: 'Professional Sports Photographer'
    }
  },
  es: {
    nav: {
      home: 'Inicio',
      gallery: 'Galería',
      about: 'Acerca de',
      testimonials: 'Testimonios',
      contact: 'Contacto'
    },
    hero: {
      title: 'Capturando la Pasión',
      subtitle: 'del Deporte',
      description: 'Fotografía deportiva profesional que captura emociones reales y momentos decisivos',
      cta: 'Ver Mi Trabajo'
    },
    about: {
      title: 'Acerca de Mí',
      bio: "Hola, soy Yamil Marquez - Fotógrafo deportivo basado en Canadá. Capturo emociones reales, momentos decisivos y la pasión del deporte. Cada foto cuenta una historia de determinación, victoria y espíritu humano.",
      experience: 'Años de Experiencia',
      projects: 'Proyectos Completados',
      sports: 'Deportes Cubiertos'
    },
    gallery: {
      title: 'Portfolio',
      subtitle: 'Una selección de mis mejores momentos capturados',
      categories: {
        all: 'Todos',
        team: 'Deportes de Equipo',
        individual: 'Deportes Individuales',
        extreme: 'Deportes Extremos',
        motor: 'Deportes de Motor'
      }
    },
    testimonials: {
      title: 'Lo que Dicen Mis Clientes',
      subtitle: 'Testimonios de clientes satisfechos',
      items: [
        {
          name: 'Marc Dubois',
          role: 'Entrenador de Baloncesto',
          text: 'Yamil capturó la esencia de nuestro equipo. Sus fotos cuentan la historia de cada partido con una emoción increíble.',
          rating: 5
        },
        {
          name: 'Sophie Laurent',
          role: 'Atleta Profesional',
          text: 'Un fotógrafo excepcional que sabe exactamente cuándo presionar el obturador. Cada foto es una obra de arte.',
          rating: 5
        },
        {
          name: 'Jean Martin',
          role: 'Director Deportivo',
          text: 'Profesionalismo y creatividad. Yamil entiende el deporte y se nota en su trabajo.',
          rating: 5
        }
      ]
    },
    contact: {
      title: 'Trabajemos Juntos',
      subtitle: 'Contáctame para discutir tu proyecto',
      form: {
        name: 'Nombre Completo',
        email: 'Email',
        phone: 'Teléfono',
        sport: 'Tipo de Deporte',
        message: 'Mensaje',
        submit: 'Enviar Mensaje',
        sending: 'Enviando...',
        success: '¡Mensaje enviado con éxito!',
        error: 'Error al enviar. Por favor intenta de nuevo.'
      },
      info: {
        title: 'Información de Contacto',
        email: 'Email',
        phone: 'Teléfono',
        location: 'Ubicación',
        instagram: 'Instagram'
      }
    },
    footer: {
      rights: 'Todos los derechos reservados.',
      tagline: 'Fotógrafo Deportivo Profesional'
    }
  }
};

export const galleryImages = [
  { id: 1, url: '/images/_MG_0100.jpg', sport: 'Sports Photography', description: 'Captured moment' },
  { id: 2, url: '/images/_MG_0278.jpg', sport: 'Sports Photography', description: 'Action shot' },
  { id: 3, url: '/images/_MG_0616.jpg', sport: 'Sports Photography', description: 'Dynamic moment' },
  { id: 4, url: '/images/_MG_0631.jpg', sport: 'Sports Photography', description: 'Peak action' },
  { id: 5, url: '/images/_MG_0845.jpg', sport: 'Sports Photography', description: 'Intense competition' },
  { id: 6, url: '/images/_MG_0885.jpg', sport: 'Sports Photography', description: 'Decisive moment' },
  { id: 7, url: '/images/_MG_1176.jpg', sport: 'Sports Photography', description: 'Game action' },
  { id: 8, url: '/images/_MG_1363.jpg', sport: 'Sports Photography', description: 'Sports emotion' },
  { id: 9, url: '/images/_MG_1693.jpg', sport: 'Sports Photography', description: 'Athletic performance' },
  { id: 10, url: '/images/_MG_2025.jpg', sport: 'Sports Photography', description: 'Championship moment' },
  { id: 11, url: '/images/_MG_2692.jpg', sport: 'Sports Photography', description: 'Victory captured' },
  { id: 12, url: '/images/_MG_2783.jpg', sport: 'Sports Photography', description: 'Team spirit' },
  { id: 13, url: '/images/_MG_4330.jpg', sport: 'Sports Photography', description: 'Game intensity' },
  { id: 14, url: '/images/_MG_4395.jpg', sport: 'Sports Photography', description: 'Athletic prowess' },
  { id: 15, url: '/images/_MG_5078.jpg', sport: 'Sports Photography', description: 'Competition heat' },
  { id: 16, url: '/images/_MG_5559.jpg', sport: 'Sports Photography', description: 'Sports passion' },
  { id: 17, url: '/images/_MG_5804.jpg', sport: 'Sports Photography', description: 'Winning moment' },
  { id: 18, url: '/images/_MG_6054.jpg', sport: 'Sports Photography', description: 'Athletic excellence' },
  { id: 19, url: '/images/_MG_6142.jpg', sport: 'Sports Photography', description: 'Game highlight' },
  { id: 20, url: '/images/_MG_6345.jpg', sport: 'Sports Photography', description: 'Sports drama' },
  { id: 21, url: '/images/_MG_6851.jpg', sport: 'Sports Photography', description: 'Peak performance' },
  { id: 22, url: '/images/_MG_6913.jpg', sport: 'Sports Photography', description: 'Athletic moment' },
  { id: 23, url: '/images/_MG_7078.jpg', sport: 'Sports Photography', description: 'Competition spirit' },
  { id: 24, url: '/images/_MG_7289.jpg', sport: 'Sports Photography', description: 'Game action' },
  { id: 25, url: '/images/_MG_7495.jpg', sport: 'Sports Photography', description: 'Sports intensity' },
  { id: 26, url: '/images/_MG_7617.jpg', sport: 'Sports Photography', description: 'Victory moment' },
  { id: 27, url: '/images/_MG_7711.jpg', sport: 'Sports Photography', description: 'Athletic dedication' },
  { id: 28, url: '/images/_MG_8086.jpg', sport: 'Sports Photography', description: 'Championship play' },
  { id: 29, url: '/images/_MG_8243.jpg', sport: 'Sports Photography', description: 'Game excitement' },
  { id: 30, url: '/images/_MG_8298.jpg', sport: 'Sports Photography', description: 'Sports energy' },
  { id: 31, url: '/images/_MG_8626.jpg', sport: 'Sports Photography', description: 'Competitive edge' },
  { id: 32, url: '/images/_MG_8752.jpg', sport: 'Sports Photography', description: 'Athletic achievement' },
  { id: 33, url: '/images/_MG_8835.jpg', sport: 'Sports Photography', description: 'Game momentum' },
  { id: 34, url: '/images/_MG_8840.jpg', sport: 'Sports Photography', description: 'Sports action' },
  { id: 35, url: '/images/_MG_8910.jpg', sport: 'Sports Photography', description: 'Victory celebration' },
  { id: 36, url: '/images/_MG_8968.jpg', sport: 'Sports Photography', description: 'Peak action' },
  { id: 37, url: '/images/_MG_9201.jpg', sport: 'Sports Photography', description: 'Championship moment' },
  { id: 38, url: '/images/_MG_9470.jpg', sport: 'Sports Photography', description: 'Sports excellence' }
];

export const contactInfo = {
  email: 'yamilmarquez97@yahoo.com',
  phone: '+15145780725',
  location: 'Canada',
  instagram: 'https://www.instagram.com/emotions_framing?igsh=ajk0NDdoNjVtY2w0&utm_source=qr',
  instagramHandle: '@emotions_framing'
};

export const stats = {
  experience: '3',
  projects: '50+',
  sports: '11+'
};
